import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Home, Users, Calendar, TrendingUp, Wallet, Bell, Activity, Settings, Wrench, LogOut, Package, ShoppingBag } from "lucide-react";
import { useAdminAuth } from "@/context/AdminAuthContext";

const NAV = [
  { to: "/admin/overview", label: "Overview", icon: Home, testid: "nav-overview" },
  { to: "/admin/astrologers", label: "Astrologers", icon: Users, testid: "nav-astrologers" },
  { to: "/admin/bookings", label: "Bookings", icon: Calendar, testid: "nav-bookings" },
  { to: "/admin/revenue", label: "Revenue", icon: TrendingUp, testid: "nav-revenue" },
  { to: "/admin/payments", label: "Payments", icon: Wallet, testid: "nav-payments" },
  { to: "/admin/notifications", label: "Notifications", icon: Bell, testid: "nav-notifications" },
  { to: "/admin/system-health", label: "System Health", icon: Activity, testid: "nav-system-health" },
  { to: "/admin/manual-actions", label: "Manual Actions", icon: Wrench, testid: "nav-manual-actions" },
  { to: "/admin/settings", label: "Settings", icon: Settings, testid: "nav-settings" },
  { to: "/admin/products", label: "Products", icon: Package, testid: "nav-products" },
  { to: "/admin/product-orders", label: "Product Orders", icon: ShoppingBag, testid: "nav-product-orders" },
];

export default function AdminLayout() {
  const { admin, logout } = useAdminAuth();
  const navigate = useNavigate();

  const signOut = () => {
    logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="flex min-h-[100dvh] w-full overflow-x-hidden bg-[var(--jk-paper)]">
      <aside className="fixed left-0 top-0 z-20 flex h-full w-[240px] flex-col border-r border-[#e9e6e1] bg-white">
        <div className="flex items-center gap-2 px-6 py-6">
          <img src="/logo.svg" alt="JothidaKural" className="h-[18px] w-auto" />
          <span className="rounded-full bg-[#111111] px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white">
            Admin
          </span>
        </div>
        <nav className="flex-1 space-y-1 px-3">
          {NAV.map(({ to, label, icon: Icon, testid }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-[12px] px-3.5 py-2.5 text-[14px] font-medium transition-colors ${
                  isActive ? "bg-[#111111] text-white" : "text-[#555] hover:bg-[#f2f0ec]"
                }`
              }
            >
              <Icon size={18} strokeWidth={1.9} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-[#e9e6e1] px-4 py-4">
          <p className="truncate px-1 text-[12px] text-[#999]" data-testid="admin-email">{admin?.email}</p>
          <button
            onClick={signOut}
            data-testid="admin-logout-btn"
            className="mt-2 flex w-full items-center gap-2 rounded-[10px] px-1 py-2 text-[13px] font-medium text-[#555] hover:text-[#c0392b]"
          >
            <LogOut size={16} /> Sign out
          </button>
        </div>
      </aside>
      <main className="ml-[240px] min-w-0 flex-1 overflow-x-hidden p-8">
        <Outlet />
      </main>
    </div>
  );
}
